// builder.config.js
import { defineConfig } from '@vueform/builder'
// Import the preset, let's call it simplePreset for clarity
import simplePreset from '@vueform/builder/presets/simple'

// You might place this anywhere else in your project
import '@vueform/builder/index.css'

// --- MODIFICATION OF THE PRESET ---
// We access the schema for the 'date' element type within the simple preset
// and directly set its default displayFormat.
if (
  simplePreset &&
  simplePreset.element &&
  simplePreset.element.types
) {
  if (
    simplePreset.element.types.date &&
    simplePreset.element.types.date.schema
  ) {
    simplePreset.element.types.date.schema.displayFormat = 'MM/DD/YYYY'
  }
  if (
    simplePreset.element.types.datetime &&
    simplePreset.element.types.datetime.schema
  ) {
    simplePreset.element.types.datetime.schema.displayFormat = 'MM/DD/YYYY HH:mm'
  }

  // Remove file upload related elements
  const fileUploadElements = [
    'file', 
    'multifile', 
    'image', 
    'images', 
    'gallery', 
    'upload', 
    'fileUpload',
    'imageUpload',
    'multiImage',
    'attachment',
    'attachments'
  ]
  
  // Remove from element types
  fileUploadElements.forEach(elementType => {
    if (simplePreset.element.types[elementType]) {
      delete simplePreset.element.types[elementType]
    }
  })
  
  // Also remove from elements list if it exists
  if (simplePreset.elements) {
    simplePreset.elements = simplePreset.elements.filter(element => 
      !fileUploadElements.includes(element)
    )
  }
  
  // Remove from element groups if they exist
  if (simplePreset.elementGroups) {
    Object.keys(simplePreset.elementGroups).forEach(groupKey => {
      if (simplePreset.elementGroups[groupKey]) {
        simplePreset.elementGroups[groupKey] = simplePreset.elementGroups[groupKey].filter(element => 
          !fileUploadElements.includes(element)
        )
      }
    })
  }
} else {
  console.warn('Vueform Builder: Could not find the expected path to override date or dateTime displayFormat in the simple preset. The preset structure might have changed.')
}

export default defineConfig({
  // Use the modified preset
  preset: simplePreset,
  // Additional configuration to ensure file elements are disabled
  element: {
    types: {
      // Explicitly exclude file-related elements
      file: false,
      multifile: false,
      image: false,
      images: false,
      gallery: false,
      upload: false,
      fileUpload: false,
      imageUpload: false,
      multiImage: false,
      attachment: false,
      attachments: false,
    }
  }
})